<template>
  <div class="terms" :class="termsWrapperClass">
    <a-lazy-hydrate when-visible>
      <a-breadcrumbs
        :settings="breadcrumbsSettings"
        class="click-spam-left-padding"
      />
    </a-lazy-hydrate>
    <nuxt-child />

    <a-visibility show :on="[$breakpoint.mobile]">
      <div class="terms__mobile-section">
        <a-top-brokers-with-delayed-refresh class="terms__top-brokers" />

        <a-banner
          :banner-settings="$options.consts.BANNER_SETTINGS.TERMS.MPU_1"
          :wrapped-in-card="true"
        />

        <a-banner
          :banner-settings="$options.consts.BANNER_SETTINGS.TERMS.MPU_2"
          :wrapped-in-card="true"
        />

        <a-banner
          :banner-settings="$options.consts.BANNER_SETTINGS.TERMS.MPU_3"
          :wrapped-in-card="true"
        />
      </div>
    </a-visibility>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import { ROUTE_NAME } from '@/utils/enums/routes'
import ABanner from 'shared/ABanner/index.vue'
import { BANNER_SETTINGS } from 'enums/banners/banner-settings'
import ATopBrokersWithDelayedRefresh from '@/components/_shared/ATopBrokersWithDelayedRefresh/index.vue'

const TERMS_HOMEPAGE_BREADCRUMB_NAME = 'Financial Terms'

export default {
  name: 'TermsHomePage',
  mixins: [mixins.setPageLoaded],
  components: {
    ATopBrokersWithDelayedRefresh,
    ABanner
  },
  consts: {
    BANNER_SETTINGS
  },
  computed: {
    breadcrumbsSettings() {
      return {
        [ROUTE_NAME.TERMS]: {
          nameHandler: () => TERMS_HOMEPAGE_BREADCRUMB_NAME
        }
      }
    },
    isTermPageRoute() {
      return this.$route.name === ROUTE_NAME.TERMS_LETTER_TERM
    },
    termsWrapperClass() {
      return {
        'term-letter': this.isTermPageRoute
      }
    }
  }
}
</script>

<style lang="scss">
.terms {
  &__see-more-less {
    margin-top: 20px;
  }
  .terms__top-brokers {
    margin: 34px 0;
  }
}
</style>
